import React, { Fragment } from 'react';
import { func, node, arrayOf, string, objectOf, any, shape } from 'prop-types';
import { noop, identity, omit } from 'lodash';
import { injectInto } from 'helpers/react';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';

export default class MenuWrapper extends React.Component {
  static propTypes = {
    items: arrayOf(
      shape({
        value: string.isRequired,
        label: string.isRequired,
        props: objectOf(any)
      })
    ).isRequired,
    onClickMenuItem: func.isRequired,
    children: node.isRequired,
    menuProps: objectOf(any),
    protectedItems: arrayOf(string),
    transformLabel: func
  };

  static defaultProps = {
    items: [],
    menuProps: {},
    onClickMenuItem: noop,
    protectedItems: ['delete'],
    transformLabel: identity
  };

  state = {
    anchorEl: null
  };

  openMenu = event => {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget
    });
  };

  closeMenu = event => {
    event.stopPropagation();
    this.setState({ anchorEl: null });
  };

  handleClickMenuItem = action => event => {
    this.closeMenu(event);
    return this.props.onClickMenuItem(action, event);
  };

  render() {
    const { items } = this.props;

    const protectedItems = items.filter(item =>
      this.props.protectedItems.includes(item.value)
    );
    const unProtectedItems = items.filter(
      item => !this.props.protectedItems.includes(item.value)
    );

    return (
      <Fragment>
        {injectInto(this.props.children, {
          onClick: this.openMenu
        })}
        <Menu
          id="menu-wrapper"
          anchorEl={this.state.anchorEl}
          open={!!this.state.anchorEl}
          onClose={this.closeMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          disableAutoFocusItem
          getContentAnchorEl={null}
          PaperProps={{
            square: true
          }}
          {...omit(this.props, [
            'items',
            'onClickMenuItem',
            'children',
            'menuProps',
            'protectedItems',
            'transformLabel'
          ])}
        >
          {unProtectedItems.map(item =>
            <MenuItem
              key={item.value}
              onClick={this.handleClickMenuItem(item.value)}
              {...item.props}
            >
              {this.props.transformLabel(item.label)}
            </MenuItem>
          )}
          {!!protectedItems.length && <Divider />}
          {protectedItems.map(item =>
            <MenuItem
              key={item.value}
              onClick={this.handleClickMenuItem(item.value)}
              {...item.props}
            >
              {this.props.transformLabel(item.label)}
            </MenuItem>
          )}
        </Menu>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/MenuWrapper/index.js